app.directive('showWhenNotVisible', ['$filter', '$rootScope', '$timeout', function($filter, $rootScope, $timeout){
    return {
        restrict: 'A',
        scope:true,
        link:function(scope, element, attrs){
            scope.show = false;
            var update = function(){
                $timeout(
                    function(){
                        var count = 0;
                        var items = $(element[0]).find('[item]');
                        var button = $(element[0]).find(".onglets-top-nav");
                        $.each(items, function(index, item){
                            if(isOverlap( $(item), button)){
                                count++;
                            }
                        });
                        scope.show = count > 0;
                        if(scope.show) {
                            $(element[0]).addClass('mar-r');
                        } else {
                            $(element[0]).removeClass('mar-r');
                        }
                    }
                )
            };
            update();
            $rootScope.$on('windowResize', update);
        }
    }
}]);

function isOverlap(elem1,elem2){
    var objOne=$(elem1),
        objTwo=$(elem2),
        offsetOne = objOne.offset(),
        offsetTwo = objTwo.offset(),
        topOne=offsetOne.top,
        topTwo=offsetTwo.top,
        leftOne=offsetOne.left,
        leftTwo=offsetTwo.left,
        widthOne = objOne.width(),
        widthTwo = objTwo.width(),
        heightOne = objOne.height(),
        heightTwo = objTwo.height();
    var leftTop = leftTwo > leftOne && leftTwo < leftOne+widthOne
            && topTwo > topOne && topTwo < topOne+heightOne,
        rightTop = leftTwo+widthTwo > leftOne && leftTwo+widthTwo < leftOne+widthOne
            && topTwo > topOne && topTwo < topOne+heightOne,
        leftBottom = leftTwo > leftOne && leftTwo < leftOne+widthOne
            && topTwo+heightTwo > topOne && topTwo+heightTwo < topOne+heightOne,
        rightBottom = leftTwo+widthTwo > leftOne && leftTwo+widthTwo < leftOne+widthOne
            && topTwo+heightTwo > topOne && topTwo+heightTwo < topOne+heightOne;
    return leftTop || rightTop || leftBottom || rightBottom;
}